import { G } from '@mobily/ts-belt';

import type { FinancialIndexShortName } from '@Common/constants/financial_indexes';

import { useFinancialIndex } from '@sh4res/bo-common/hooks/useFinancialIndex';

export function useFinancialIndexValue(shortName: FinancialIndexShortName): number | null {
  const { index } = useFinancialIndex(shortName);

  return G.isNullable(index?.value) ? null : index.value;
}
